import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {PlgSearchModel} from "../plg-search.model";
import {PlgEntityModel} from "../plg-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-plg-search-page",
    templateUrl: "./plg-search-page.component.html",
    providers: [provideSearchModel(PlgSearchModel), provideEntityModel(PlgEntityModel)]
})
export class PlgSearchPageComponent extends AbstractSearchPage {
}
